import { defineNuxtPlugin } from "nuxt/app";
import type { ConfigDefaults } from "posthog-js";
import posthog from "posthog-js";

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig();
  const posthogClient = posthog.init(runtimeConfig.public.posthogPublicKey as string, {
    api_host: runtimeConfig.public.posthogHost as string,
    defaults: runtimeConfig.public.posthogDefaults as ConfigDefaults,
    person_profiles: "always",
    loaded: (posthog) => {
      if (nuxtApp.isDev) posthog.debug();
    },
  });

  // capture all errors, even if it is handled by the app
  // nuxtApp.vueApp.config.errorHandler = (error) => {
  //   console.log("error being sent to posthog", error);
  //   if (import.meta.env.PROD) {
  //     posthogClient.captureException(error);
  //   }
  // };

  // capture unhandled vue errors
  // nuxtApp.hook("vue:error", (error) => {
  //   console.log("unhandled vue error being sent to posthog", error);
  //   posthogClient.captureException(error);
  // });

  return {
    provide: {
      posthog: () => posthogClient,
    },
  };
});
